import React, {useState} from 'react';
import './meals.scss';
import ArrowLeftLineIcon from '@rsuite/icons/ArrowLeftLine';
import TimeIcon from '@rsuite/icons/Time';
import {Button, Input, InputGroup, Loader, Modal, Placeholder, Radio, RadioGroup, Slider} from "rsuite";
import SearchIcon from "@rsuite/icons/Search";
import PlusIcon from "@rsuite/icons/Plus";
import AuthService from "../../../../services/auth.service";
import {toast} from "react-toastify";
import axios from "axios";
import SliderBanner from "../slider_banner/sliderBanner";
import BottomSheet from "../bottom_sheet/BottomSheet";
import Buttons from "../../../buttons/buttons";
import MealTrial from "./MealTrial";

const APP_URL = process.env.APP_URL;

const Meals = (params) => {
    const {mealsItems, data, activeUserSubscription, isExpired, sync, trial, changeDay} = params;
    const [isLoading1, setIsLoading1] = useState(params.isLoading);
    const [replacementModalStatus, setReplacementModalStatus] = useState(false);
    const [replacementModalTitle, setReplacementModalTitle] = useState('انتخاب در لیست وعده ها');
    const [activeFreeMeals, setActiveFreeMeals] = useState(null);
    const [activeMeal, setActiveMeal] = useState(null);
    // const [activeDateContent, setActiveDateContent] = useState(null);
    const [selectedFreeMeal, setSelectedFreeMeal] = useState(null);
    //const mealsItems={activeDateContent.meals}
    const [bottomSheetConfig, setBottomSheetConfig] = useState({});
    const {showCalorieStatus}= params;

    function bottomSheetHandler(config) {
        setBottomSheetConfig(config);
    }

    return (
        <>
            {trial ? <MealTrial data={trial} changeDay={changeDay}/> : ''}
            <div className={`meals ${trial ? 'trial-meals' : ''}`}>
                {
                    mealsItems.map((meal, mealIndex) => {
                        return (<>
                                <div className="meal-col" key={mealIndex}>
                                    <div className="meal">
                                        <div className="meals-type">
                                            {meal.featured_image ? (
                                                <div className="featured-image-container">
                                                    <img src={meal.featured_image} alt="food"/>
                                                </div>) : ''}

                                            <div className="meal-title">
                                                {meal.meal_type ? meal.meal_type : 'وعده غذایی'}
                                            </div>
                                            {meal.features.includes('replacement') ? <button
                                                    onClick={e => openReplaceModal(meal)}
                                                    className="btn-replace"
                                                    style={{'display': activeUserSubscription === null || isExpired ? 'none' : 'block'}}>
                                                    جایگزین
                                                    <ArrowLeftLineIcon/>
                                                </button>
                                                : ''}
                                        </div>

                                        <div className="foods">
                                            {meal.foods.map((food, foodIndex) => {
                                                return (<div
                                                    key={foodIndex}
                                                    className="food">
                                                    {food.summary}
                                                </div>);
                                            })}
                                        </div>


                                        <div className="meal-excerpt">
                                            <TimeIcon/>
                                            بهترین زمان مصرف :
                                            <strong>
                                                {meal.meal_type_excerpt}
                                            </strong>
                                        </div>
                                        { showCalorieStatus?.calorie_text==1 &&( <div className="meal-calorie">{meal?.calorie_text}</div>) }
                                    </div>
                                </div>

                                {meal.buttons ? <Buttons buttons={meal.buttons}
                                                         bottomSheetConfig={bottomSheetConfig}
                                                         bottomSheetHandler={bottomSheetHandler}/> : ''}

                                {/*{meal.banner ? <SliderBanner key={(mealIndex + 1) * 1000} data={meal.banner}/> : ''}*/}
                            </>
                        );
                    })
                }
            </div>

            <BottomSheet bottomSheetConfig={bottomSheetConfig}
                         bottomSheetHandler={bottomSheetHandler}/>

            <Modal open={replacementModalStatus} onClose={closeReplaceModal}>
                <Modal.Header>
                    <Modal.Title>{replacementModalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {activeFreeMeals ? (<div className="free-meals-container">
                        <div className="search-box">
                            <InputGroup inside>
                                <Input
                                    onChange={value => replaceModalSearch(value)}
                                    placeholder="دنبال چه غذایی می گردی؟"/>
                                <InputGroup.Button>
                                    <SearchIcon/>
                                </InputGroup.Button>
                            </InputGroup>
                        </div>

                        <div className="free-meals">
                            <RadioGroup name="free_meals">
                                {activeFreeMeals.map((activeFreeMeal, activeFreeMealIndex) => {
                                    return <Radio
                                        onChange={e => selectFreeMeal(activeFreeMeal)}
                                        key={activeFreeMealIndex}
                                        value={activeFreeMeal.id}>{activeFreeMeal.foods.map(food => food.summary).join('،')}</Radio>
                                })}
                            </RadioGroup>
                        </div>
                    </div>) : (
                        <>
                            <Placeholder.Paragraph rows={8}/>
                            <Loader backdrop content="درحال بارگزاری..." vertical/>
                        </>)
                    }
                </Modal.Body>
                <Modal.Footer>
                    {selectedFreeMeal ? (
                        <Button className="btn-replace-modal-save"
                                disabled={isLoading1}
                                onClick={saveReplaceMeal} appearance="primary">
                            {isLoading1 ? <Loader size="xs"/> : <PlusIcon/>}
                            جایگزین کردن این وعده در لیست
                        </Button>
                    ) : ''}
                </Modal.Footer>
            </Modal>
        </>
    )

    function openReplaceModal(meal) {
        setActiveFreeMeals(null);
        setReplacementModalStatus(true);
        setSelectedFreeMeal(null);
        setActiveMeal(meal);
        setActiveFreeMeals(data.free_meals.filter(freeMeal => freeMeal.meal_type_id === meal.meal_type_id).flat());
        setReplacementModalTitle(`انتخاب در لیست وعده های ${meal.meal_type}`);
    }

    function replaceModalSearch(value) {
        if (value.length <= 1) {
            setActiveFreeMeals(data.free_meals.filter(freeMeal => freeMeal.meal_type_id === activeMeal.meal_type_id).flat());
        }

        const meals = data.free_meals.filter(freeMeal => freeMeal.meal_type_id === activeMeal.meal_type_id).flat();
        const result = meals
            .filter(activeFreeMeal => {
                const summaries = activeFreeMeal.foods.map(food => food.summary).join(' ');
                return summaries.includes(value);
            })
            .flat();

        setActiveFreeMeals(result);
    }

    function selectFreeMeal(freeMeal) {
        setSelectedFreeMeal(freeMeal);
    }

    function saveReplaceMeal() {
        //setIsLoading1(true);

        const config = {
            headers: {Authorization: `Bearer ${AuthService.getAccessToken()}`}
        };

        const body = {
            day_meal_id: activeMeal.id,
            free_meal_id: selectedFreeMeal.id,
        };

        axios.post(`${APP_URL}/api/user-meals/update`, body, config)
            .then(function (response) {
                toast.success(response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });

                closeReplaceModal();
                sync();

            })
            .catch(function (error) {
                setIsLoading1(false);

                if (!error.response) {
                    handleNotfound();


                    return false;
                }

                const statusCode = error.response.status;
                switch (statusCode) {
                    case 422:
                        const {errors} = error.response.data;

                        for (const errorsKey in errors) {
                            const error = errors[errorsKey][0];

                            toast.error(error, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                        }
                        break;

                    case 401:
                        AuthService.logout();
                        window.location.replace('/');
                        break;
                    default:
                        handleNotfound();

                        break;
                }
            });
    }

    function closeReplaceModal() {
        setReplacementModalStatus(false);
    }


    function handleNotfound() {

        localStorage.setItem("error", 'PageNotFound');
        setIsLoading1(false);
        //setStep('notfound');
        window.location.href = '';
    }


}
export default Meals;
